module.exports = __webpack_public_path__ + "static/media/r6s3.062eed33.jpg";